export default {
  'Life': {
    '2x2': '125/36',
    '34 Life': '34/34',
    'Amoeba': '1358/357',
    'Assimilation': '4567/345',
    'Coagulations': '235678/378',
    'Conway\'s Game of Life': '23/3',
    'Coral': '45678/3',
    'Day & Night': '34678/3678',
    'Diamoeba': '5678/35678',
    'Flakes': '012345678/3',
    'Gnarl': '1/1',
    'HighLife': '23/36',
    'InverseLife': '34678/0123478/2',
    'Long life': '/345',
    'Maze': '/3',
    'Mazectric': '1234/3',
    'Move': '/368',
    'Pseudo life': '238/357',
    'Replicator': '1357/1357',
    'Seeds (2)': '/2',
    'Serviettes': '/234',
    'Stains': '235678/3678',
    'WalledCities': '2345/45678'
  },
  'Generations': {
    'Banners': '2367/3457/5',
    'BelZhab': '23/23/8',
    'BelZhab Sediment': '145678/23/8',
    'Bloomerang': '234/34678/24',
    'Bombers': '345/24/25',
    'Brain 6': '6/246/3',
    'Brian\'s Brain': '/2/3',
    'Burst': '0235678/3468/9',
    'BurstII': '235678/3468/9',
    'Caterpillars': '124567/378/4',
    'Chenille': '05678/24567/6',
    'Circuit Genesis': '2345/1234/8',
    'Cooties': '23/2/8',
    'Ebb&Flow': '012478/36/18',
    'Ebb&Flow II': '012468/37/18',
    'Faders': '2/2/25',
    'Fireworks': '2/13/21',
    'Flaming Starbows': '347/23/8',
    'Frogs': '12/34/3',
    'Frozen spirals': '356/23/6',
    'Glisserati': '035678/245678/7',
    'Glissergy': '035678/245678/5',
    'Lava': '12345/45678/8',
    'Lines': '012345/458/3',
    'LivingOn TheEdge': '345/3/6',
    'Meteor Guns': '01245678/3/8',
    'Nova': '45678/2478/25',
    'OrthoGo': '3/2/4',
    'Praire on fire': '345/34/6',
    'RainZha': '2/23/8',
    'Rake': '3467/2678/6',
    'SediMental': '45678/25678/4',
    'Snake': '03467/25/6',
    'SoftFreeze': '13458/38/6',
    'Spirals': '2/234/5',
    'Star Wars': '345/2/4',
    'Sticks': '3456/2/6',
    'Swirl': '23/34/8',
    'ThrillGrill': '1234/34/48',
    'Transers': '345/26/5',
    'TransersII': '0345/26/6',
    'Wanderers': '345/34678/5',
    'Worms': '3467/25/6',
    'Xtasy': '1456/2356/16'
  },
  'Larger than Life': {
    'Bugs': {
      birth: [34,35,36,37,38,39,40,41,42,43,44,45],
      survival: [34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58],
      includeCenter: true,
      range: 5
    },
    'Bugsmovie': {
      birth: [123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170],
      survival: [123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223],
      range: 10,
      includeCenter: true
    },
    'Globe': {
      birth: [123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170],
      survival: [163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223],
      range: 8,
      includeCenter: false
    },
    'Gnarl': {
      birth: [1],
      survival: [1],
      neighborhoodType: 1
    },
    'Majority': {
      birth: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81],
      survival: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81],
      range: 4,
      includeCenter: true
    },
    'Majorly': {
      birth: [113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225],
      survival: [113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225],
      range: 7,
      includeCenter: true
    },
    'ModernArt': {
      birth: [3],
      survival: [2,3],
      range: 10,
      includeCenter: true,
      historyEnabled: true,
      stateCount: 255
    },
    'Waffle': {
      birth: [75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170],
      survival: [100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200],
      range: 7,
      includeCenter: true
    }
  }
}